import type { InvoiceType, NexDetailLine } from '../types/invoice';

/** Build `manualMatches[].nexLine` payload for save / submit / refresh NEX. */
export function nexDetailLineToManualMatchPayload(
    nexLine: NexDetailLine,
    _invoiceType?: InvoiceType,
): NexDetailLine {
    return {
        partNumber: nexLine.partNumber,
        partDesc: nexLine.partDesc,
        ...(nexLine.qtyOnOrder != null && Number.isFinite(nexLine.qtyOnOrder) ? { qtyOnOrder: nexLine.qtyOnOrder } : {}),
        qty: nexLine.qty,
        ...(nexLine.qtyRec != null && Number.isFinite(nexLine.qtyRec) ? { qtyRec: nexLine.qtyRec } : {}),
        listPrice: nexLine.listPrice,
        unitCost: nexLine.unitCost,
        extendedCost: nexLine.extendedCost,
        poHeaderID: nexLine.poHeaderID,
        lineNumber: nexLine.lineNumber,
        unqSeq: nexLine.unqSeq,
        ...(typeof nexLine.ciecaCode === 'string' && nexLine.ciecaCode.trim()
            ? { ciecaCode: nexLine.ciecaCode.trim() }
            : {}),
        _poVendorName: nexLine._poVendorName,
        ...(nexLine._nexMatchSource ? { _nexMatchSource: nexLine._nexMatchSource } : {}),
    };
}

export function manualMatchesFromOverrides(
    overrides: Record<number, NexDetailLine>,
    invoiceType?: InvoiceType,
): Array<{ partIndex: number; nexLine: NexDetailLine }> {
    return Object.entries(overrides).map(([k, nexLine]) => ({
        partIndex: parseInt(k, 10),
        nexLine: nexDetailLineToManualMatchPayload(nexLine, invoiceType),
    }));
}

/** Resolve matched NEX line for a global part index (server match + local override). */
export function resolveMatchedNexLineForPartIndex(
    partIndex: number,
    matchedNexLines: Array<{ partIndex: number; nexLine: NexDetailLine }>,
    localOverrides: Record<number, NexDetailLine>,
    unmatchedPartIndices: Set<number>,
): NexDetailLine | undefined {
    if (unmatchedPartIndices.has(partIndex)) return undefined;
    if (localOverrides[partIndex] !== undefined) {
        return localOverrides[partIndex];
    }
    return matchedNexLines.find((m) => m.partIndex === partIndex)?.nexLine;
}
